import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { DeactivateAccountModalComponent } from './deactivate-account-modal.component';
import { DeactivateOrDeleteAccountSharedModule } from '../deactivate-or-delete-account-shared/deactivate-or-delete-account-shared.module';

@NgModule({
  imports: [
    CommonModule,
    DeactivateOrDeleteAccountSharedModule,
    TrackingModule,
    UiModule,
  ],
  declarations: [DeactivateAccountModalComponent],
  exports: [DeactivateAccountModalComponent],
})
export class DeactivateAccountModalModule {}
